import Reflux from 'reflux'
import UtilActions from '../actions/UtilActions'

export var GetGridInfosStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(UtilActions.getGridInfos,'onGetGridInfos');
	},
    onGetGridInfos(groupAlias,result,moduleInstanceId)
    {
		this.trigger(groupAlias,result,moduleInstanceId);
    }
});

export var UpdateFetchAllIconStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(UtilActions.updateFetchAllIcon,'onUpdateFetchAllIcon');
	},
	onUpdateFetchAllIcon(groupAlias,end,moduleInstanceId)
	{
		this.trigger(groupAlias,end,moduleInstanceId);
	}
});

export var UpdateInnerToolBarStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(UtilActions.updateInnerToolBar,'onUpdateInnerToolBar');
	},
	onUpdateInnerToolBar(obj)
	{
		this.trigger(obj);
	}
});

export var KeyDownHelperStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(UtilActions.keyDownCast,'onKeyDownCast');
	},
	onKeyDownCast(e,arg)
	{
		this.trigger(e,arg);
	}
});

export var TabpageUserChangedStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(UtilActions.tabpageUserChanged,'onTabPageUserChanged');
	},
	onTabPageUserChanged(arg)
	{
		this.trigger(arg);
	}

});

export var GetDataGridColumnInfoStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(UtilActions.getDataGridColumnInfo,'onGetDataGridColumnInfo');
	},
	onGetDataGridColumnInfo(arg)
	{
		this.trigger(arg);
	}

});

export var UpdateDataGridStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(UtilActions.updateDataGrid,'onUpdateDataGrid');
	},
	onUpdateDataGrid(formId,gridId)
	{
		this.trigger(formId,gridId);
	}

});

export var DynamicColumnStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(UtilActions.dynamicColumns,'onDynamicColumns');
	},
	onDynamicColumns(arg)
	{
		this.trigger(arg);
	}

});

export var UtilStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(UtilActions.updateControlLabel,'onUpdateControlLabel');
	},
	onUpdateControlLabel(arg)
	{
		this.trigger(arg);
	}

});


// WEBPACK FOOTER //
// ./src/stores/UtilStores.js